import range from 'lodash/range';
import moment, { Moment } from 'moment';

export const generateDatesToDisplayOnAvailabilityCalendar = (endDate: string): Moment[] => {
    const today = moment();
    const endDateMoment = moment(endDate);

    let dates: Moment[] = [];
    let i = 1;

    // each iteration adds one week (7 days, each day == moment object) to the array
    // and we keep adding next weeks until we find `endDate` in the array
    // or if we reach 6 weeks to not fall into infinite loop if something goes wrong
    do {
        const nextWeek = range((i - 1) * 7, i * 7).map(modifier =>
            today.clone().add(modifier, 'days'),
        );

        dates = [...dates, ...nextWeek];
        i++;
    } while (!dates.some(date => date.isSame(endDateMoment, 'day')) && i < 7);

    return dates;
};
